import { Box, Stack, Typography } from "@mui/material";
import React from "react";
import Form from "@goola/form-goola";
import strings from "../helper/strings";
import { Affiliate } from "../interfaces/affiliate";
interface JoinFormProps {
  scrollContactUsRef: React.MutableRefObject<any>;
  affiliate: Affiliate;
}

function JoinForm(props: JoinFormProps) {
  return (
    <Box
      ref={props.scrollContactUsRef}
      mt={9.5}
      borderRadius={4}
      boxShadow="0px 45px 65px rgba(51, 51, 51, 0.15)"
      sx={{
        display: "flex",
        flexWrap: "wrap",
        alignSelf: "center",
        bgcolor: "#421763",
        mx: 5.875,
      }}
    >
      <Stack
        direction="column"
        alignItems="center"
        justifyContent="center"
        px={5}
        py={7.25}
      >
        <Typography
          sx={{
            color: "white",
            fontSize: { xs: 24, sm: 42 },
            maxWidth: 800,
            direction: "rtl",
            textAlign: "center",
            pb: 4,
          }}
        >
          {strings.main.contactUs}
        </Typography>
        {Object.keys(props.affiliate).length > 0 && (
          <Form affiliate={props.affiliate} />
        )}
      </Stack>
    </Box>
  );
}

export default JoinForm;
